module.exports = __webpack_public_path__ + "img/maneken_pos_3_back.4daf764e.png";